import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaMicrophone, FaBars, FaTimes, FaEnvelope } from 'react-icons/fa';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  // Email protection function
  const revealEmail = (e) => {
    e.preventDefault();
    const name = 'coleman';
    const domain = 'dubbah';
    const tld = 'co';
    window.location.href = `mailto:${name}@${domain}.${tld}`;
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <FaMicrophone className="logo-icon" />
            <span className="logo-text">DUBBAH</span>
          </Link>
        </div>

        <button className="mobile-menu-button" onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/lynx">Lynx</Link></li> {/* Added Lynx link */}
            <li><Link to="/services">Services</Link></li>
            <li>
              <a href="#" onClick={revealEmail} className="cta-button">
                <FaEnvelope className="icon-margin-right" /> Contact Us
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
